import {COMPANY_PANEL} from "app/config/urls/prefixes";
const prefix = `${COMPANY_PANEL}/dashboard`;

// pc = panel.company

export const dashboardRoutes = {
  'pc.dashboard': `${prefix}`,
}
